<template>
    <div class="delivery">
        <img class="image" src="../../assets/showcase/xi/detail/delivery/1.png" @click="goHistory"/>
        <img class="image" src="../../assets/showcase/xi/detail/delivery/2.png" />
        
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/delivery/3.png" />
            <div class="button1" @click="goDetail">
            
            </div>
            <div class="button2" @click="goQuestionnaire">
        
            </div>
            <div class="button3">
        
            </div>
            <div class="button4" @click="goMedicine">

            </div>
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/delivery/4.png" style="margin-top: -6px;" />
    </div>
</template>

<script>
export default {
    methods: {
        goDetail: function()
        {
            this.$emit('goDetailTab');
        },
        goQuestionnaire: function()
        {
            this.$emit('goQuestionnaireTab');
        },
        goMedicine: function()
        {
            this.$emit('goMedicineTab');
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        }

    }
}
</script>

<style scoped>
    .delivery {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        position: relative;
        width: 100%;
    }
 .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 18%;
        aspect-ratio: 2/1.3;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 15%;
        aspect-ratio: 2/1.6;
        top: 0;
        left: 38%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 21%;
        aspect-ratio: 2/1.1;
        top: 0;
        left: 53%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Delivery.vue